if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.onOptionChange = this.onOptionChange.bind(this);
    }

    get selectedOptionValues() {
      const fields = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();
      fields.forEach((field) => {
        const name = field.name || field.dataset.fieldName;
        if (field.tagName === 'SELECT') {
          const option = Array.from(field.options).find((item) => item.selected && !item.disabled);
          if (option) selectedValues.set(name, option.dataset.optionValueId);
        } else if (field.type === 'radio' && field.checked) {
          selectedValues.set(name, field.dataset.optionValueId);
        }
      });
      // Preserve the theme's fallback when default selections are disabled.
      fields.forEach((field) => {
        const name = field.name || field.dataset.fieldName;
        if (selectedValues.has(name)) return;
        const option = field.tagName === 'SELECT'
          ? Array.from(field.options).find((item) => !item.disabled)
          : field.type === 'radio' ? field : null;
        if (option) selectedValues.set(name, option.dataset.optionValueId);
      });
      return Array.from(selectedValues.values()).filter(Boolean);
    }

    connectedCallback() {
      this.addEventListener('change', this.onOptionChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onOptionChange);
    }

    onOptionChange(event) {
      const target = this.getInputForEventTarget(event.target);
      if (!target || !target.dataset.optionValueId) return;
      MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, {
        data: { selectedOptionValues: this.selectedOptionValues, event, target }
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}